import {Typography} from '@viptech/react-components'
import Loading from '../Loading'
import {useState, useEffect} from 'react'
import {InfiniteScrollLoadingContainer} from './InfiniteScrollLoadingStykes'

export default function InfiniteScrollLoading({isLoading, bottom}: {isLoading: boolean; bottom?: number}) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true)
    } else {
      const timeout = setTimeout(() => {
        setIsVisible(false)
      }, 400)
      return () => clearTimeout(timeout)
    }
  }, [isLoading])

  if (!isVisible) {
    return null
  }

  return (
    <InfiniteScrollLoadingContainer $isVisible={isLoading} $bottom={bottom}>
      <Loading width='16px' />
      <Typography variant='h4' size='16px' color='primary'>
        Buscando mais itens...
      </Typography>
    </InfiniteScrollLoadingContainer>
  )
}
